import { Header } from '../../components/header'
import { AboutUs } from '../../components/aboutUs'
import { Banner } from '../../components/bannerHome'
import { Footer } from '../../components/footer'
import bannerImage from '../../assets/images/twoDoctors.jpg'
import './style.css'

export function About() {
  return (
    <div className="about-page">
      <Header />
      <main>
        <section>
          <Banner
            title="VidaPlus"
            subtitle="Sua solução completa para uma vida mais saudável"
            backgroundImage={`url(${bannerImage})`}
          />
        </section>
        <AboutUs
          image={bannerImage}
          title="VidaPlus Donec fermentum odio tristique facilisis dictum. Curabitur nec."
          description="Aenean luctus libero ac felis sollicitudin, sed vehicula diam tincidunt. Aliquam est eros, mollis in mattis at, elementum vel nisl. Ut feugiat est id neque lobortis, vitae finibus nibh lacinia. Integer ut augue vel metus egestas scelerisque id et felis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent semper tortor risus, quis ullamcorper diam vulputate vitae. Sed non rhoncus nulla, quis pulvinar urna. Praesent luctus rutrum sem sit amet consectetur. Quisque condimentum sem enim, ut ultricies lacus rhoncus sit amet. Nunc vehicula ante quis congue rutrum. Curabitur ut risus hendrerit, iaculis elit nec, efficitur nibh. Aenean eget urna laoreet enim posuere condimentum. Morbi ac nunc sodales, bibendum velit eget, faucibus neque."
        />
      </main>
      <Footer />
    </div>
  )
}
